Array.prototype.clone = function() {
	return JSON.parse(JSON.stringify(this));
};

Array.prototype.sortByName = function(property=null) {
    if(property != null){
        this.sort( (a, b) => {         
            const name1 = a[property].toLowerCase();
            const name2 = b[property].toLowerCase();
            
            return name1 > name2 ? 1 : name1 < name2 ? -1 : 0;    
        });
    }else{
        this.sort( (a, b) => {         
            const name1 = a.name.toLowerCase();
            const name2 = b.name.toLowerCase();
            
            return name1 > name2 ? 1 : name1 < name2 ? -1 : 0;    
        });
    }
    

    return this;
};

Array.prototype.move = function(fromIndex, toIndex) {
    this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
};

Array.prototype.moveUp = function(fromIndex) {
    if (fromIndex === 0) return;    
    this.splice(fromIndex - 1, 0, this.splice(fromIndex, 1)[0]);
};

Array.prototype.moveDown = function(fromIndex) {
    if (fromIndex + 1 === this.length) return;
    this.splice(fromIndex + 1, 0, this.splice(fromIndex, 1)[0]);
};

// by Value

Array.prototype.any = function(item) {
    return this.some(e => e === item);    
};

Array.prototype.add = function(item) {
    const index = this.findIndex(e => e === item);
    if (index !== -1) return;

    this.push(item);
};

Array.prototype.remove = function(item) {
    const index = this.findIndex(e => e === item);
    if (index === -1) return;

    this.splice(index, 1);
};

// by ID

Array.prototype.anyWithId = function(id) {
    return this.some(e => e.id === id);    
};

Array.prototype.findById = function(id) {
    return this.find(e => e.id === id);    
};

Array.prototype.findIndexById = function(id) {
    return this.findIndex(e => e.id === id);    
};

Array.prototype.updateById = function(id, item) {
    const index = this.findIndex(e => e.id === id);
    if (index === -1) return;

    this[index] = item;
};

Array.prototype.addIfIdNotExist = function(id, item) {
    const index = this.findIndex(e => e.id === id);
    if (index !== -1) return;

    this.push(item);
};

Array.prototype.removeById = function(id) {
    const index = this.findIndex(e => e.id === id);
    if (index === -1) return;

    this.splice(index, 1);
};

Array.prototype.listByIds = function(ids) {
    var items = [];

    ids.forEach(id => {
        const item = this.findById(id);
        if (item) {
            items.push(item);
        }
    }); 

    return items;
};

Array.prototype.lastId = function() {
    return this.reduce( (max, item) => item.id > max ? item.id : max, 0 );
};

// by Name

Array.prototype.anyWithName = function(name) {
    return this.some(e => e.name === name);    
};

Array.prototype.findByName = function(name) {
    return this.find(e => e.name === name);    
};

Array.prototype.findIndexByName = function(name) {
    return this.findIndex(e => e.name === name);    
};

Array.prototype.removeByName = function(name) {
    const index = this.findIndex(e => e.name === name);
    if (index === -1) return;

    this.splice(index, 1);
};

// Insertions

Array.prototype.insertionIndex = function(insertionType) {
    switch (insertionType) {
        case 'first': return 0;            
        case 'last': return this.length;
        default: return this.length;            
    }    
};

Number.prototype.insertionIndex = function(insertionType) {
    switch (insertionType) {
        case 'first': return 0;            
        case 'last': return this;
        default: return this;            
    }    
};